import { getRouteApi } from '@tanstack/react-router';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { useRequestConsorsNotesMutation } from './hooks/useRequestConsorsNotesMutation';
import Spinner from '~/components/icons/Spinner';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import useLead from '~/features/leadDetails/hooks/useLead';
import { cn } from '~/utils/cnTailwind';

export const NotesListHeader = () => {
    const { t } = useTranslation();
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { data: lead } = useLead(leadId);
    const { isPending, mutate: refreshNotes } = useRequestConsorsNotesMutation(leadId);
    const disabled =
        isPending ||
        !lead?.consors?.subscriptionIdentifier ||
        !permissions.commands[AGGREGATE_NAMES.LOAN_REQUEST].requestConsorsNotes;
    return (
        <div className="flex justify-between items-center my-4">
            <div className="text-grey text-xs font-bold">{t('CONSORS_NOTES.LIST_HEADER')}</div>
            <button
                className={cn(
                    'border border-grey text-grey bg-white hover:border-blue hover:bg-blue hover:text-white font-sans text-sm py-2 px-4 rounded w-28 transition-colors',
                    disabled && 'opacity-50 cursor-not-allowed',
                )}
                onClick={() => refreshNotes()}
                disabled={disabled}
            >
                <span className="flex items-center justify-center h-5">
                    {isPending ? <Spinner className="w-5 h-5" /> : t('CONSORS_NOTES.REFRESH')}
                </span>
            </button>
        </div>
    );
};
